import type { EmailExclusionJob } from './types';
import _ from 'lodash';

const getErrorType = (message: string | null) => {
  if (!message) return null;
  if (message.startsWith('IMPORT')) return 'importing';
  if (message.startsWith('PROCESS')) return 'processing';
  return 'finalizing';
};

export const getEmailExclusionJobProgressAndText = (job: EmailExclusionJob) => {
  let progress;
  let text;
  const errorType = getErrorType(job.failureReason);

  if (job.status === 'pending') {
    progress = 0;
    text = 'This job is pending for processing';
  } else if (job.status === 'importing' || errorType === 'importing') {
    const numOfExclusionFiles = job.exclusionFiles.length,
      numOfProcessedExclusionFiles = job.exclusionFiles.filter(
        file => file.status === 'imported' || file.status === 'failed',
      ).length,
      numOfCampaignFiles = job.campaignFiles.length,
      numOfProcessedCampaignFiles = job.campaignFiles.filter(
        file => file.status === 'imported' || file.status === 'failed',
      ).length;
    const numOfFiles = numOfExclusionFiles + numOfCampaignFiles,
      numOfProcessedFiles =
        numOfProcessedExclusionFiles + numOfProcessedCampaignFiles;
    progress = 33 * (numOfProcessedFiles / numOfFiles);
    if (job.failureReason) {
      text = `There was an error while importing files`;
    } else {
      text = `The files is being imported (${numOfProcessedFiles}/${numOfFiles} files imported)`;
    }
  } else if (job.status === 'imported') {
    progress = 100 / 3;
    text = 'All files are imported';
  } else if (
    job.status === 'processing' ||
    (errorType === 'processing' && job.status !== 'processed')
  ) {
    const numOfCampaignFiles = job.campaignFiles.length,
      numOfProcessedCampaignFiles = job.campaignFiles.filter(
        file => file.status === 'processed',
      ).length;
    const processProgress = numOfProcessedCampaignFiles / numOfCampaignFiles;
    if (processProgress < 1) {
      progress = 34 + 33 * (numOfProcessedCampaignFiles / numOfCampaignFiles);
      if (job.failureReason) {
        text = `There was an error while processing files`;
      } else {
        text = `The files is being processed (${numOfProcessedCampaignFiles}/${numOfCampaignFiles} files processed)`;
      }
    } else {
      progress = (100 * 2) / 3;
      // Finalizing the job
      if (job.failureReason) {
        text = `There was an error while finalizing the job`;
      } else {
        text = `The job is being finalized`;
      }
    }
  } else {
    progress = 100;
    text = 'This job is completed';
  }
  return { progress, text, errorType };
};

export const getCampaignFolderOrdering = (job: EmailExclusionJob) => {
  const { campaignFiles } = job;
  const campaignFolderOrdering = _.orderBy(campaignFiles, 'priority').map(
    file => file.folder,
  );
  const folders = new Set([]);
  campaignFolderOrdering.forEach(folder => folders.add(folder));
  return Array.from(folders);
};
